export default __webpack_public_path__ + "static/media/GR00009-user_female.94a8bd9c.svg";